export default function Process() {
  const steps = [
    {
      number: '01',
      icon: 'ri-search-eye-line',
      title: 'Inspection',
      description: 'Comprehensive vehicle assessment to identify all damage and required repairs'
    },
    {
      number: '02',
      icon: 'ri-file-list-3-line',
      title: 'Service Plan',
      description: 'Detailed repair plan with transparent pricing and timeline for your approval'
    },
    {
      number: '03',
      icon: 'ri-tools-fill',
      title: 'Expert Repair',
      description: 'Certified technicians perform repairs using quality parts and advanced techniques'
    },
    {
      number: '04',
      icon: 'ri-checkbox-circle-line',
      title: 'Quality Check',
      description: 'Thorough inspection to ensure all repairs meet our high standards before delivery'
    }
  ];

  return (
    <section id="process" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-amber-100 rounded-full mb-4">
            <i className="ri-roadster-line text-amber-600"></i>
            <span className="text-sm text-amber-900 font-semibold">How It Works</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 font-['Space_Grotesk'] mb-4">
            Our Simple 4-Step Process
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From initial inspection to final delivery, we make auto body repair straightforward and stress-free
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="text-center">
                <div className="relative inline-block mb-6">
                  <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl shadow-lg">
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                  <div className="absolute -top-2 -right-2 w-10 h-10 flex items-center justify-center bg-gray-900 text-white text-sm font-bold rounded-full">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 font-['Space_Grotesk']">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-0.5 bg-gradient-to-r from-amber-300 to-transparent -ml-4"></div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 p-8 bg-gradient-to-r from-amber-500 to-orange-600 rounded-2xl text-center">
          <h3 className="text-2xl font-bold text-white mb-3 font-['Space_Grotesk']">
            Ready to Get Started?
          </h3>
          <p className="text-white/90 mb-6 max-w-2xl mx-auto">
            Contact us today for a free estimate. Most repairs completed within 3-5 business days.
          </p>
          <a 
            href="tel:3105272838"
            className="inline-flex items-center space-x-2 px-8 py-4 bg-white text-gray-900 font-semibold rounded-lg hover:shadow-xl transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            <span>Call (310) 527-2838</span>
          </a>
        </div>
      </div>
    </section>
  );
}
